import { importedPageSource } from '../../../shared/importSource'
import type { Frame } from '../../../shared/types'
import { ContextMenuItem, ContextMenuSeparator } from '../../components/ui/context-menu'
import { useStore } from '../../lib/store'
import { useT } from '@/lib/i18n'
import { hideHeatmap, showHeatmap, useHeatmaps, usePostHogConnected, type HeatmapKind } from './heatmaps'

/** The frame menu's PostHog rows, for people with PostHog connected and on
 *  frames imported from a live page only:
 *  that page's clicks or rage clicks, or Hide once one is showing. */
export function HeatmapMenuItem({ frame }: { frame: Frame }) {
  const canvasId = useStore((s) => s.canvas?.id)
  const shown = useHeatmaps((s) => s.frames[frame.id]?.kind)
  const connected = usePostHogConnected()
  const t = useT()
  if (!canvasId || !connected || !importedPageSource(frame.html)) return null
  const show = (kind: HeatmapKind) => void showHeatmap(canvasId, frame.id, kind)
  return (
    <>
      <ContextMenuSeparator />
      {shown !== 'click' && (
        <ContextMenuItem onSelect={() => show('click')}>{t('stage.posthogShowClicks')}</ContextMenuItem>
      )}
      {shown !== 'rageclick' && (
        <ContextMenuItem onSelect={() => show('rageclick')}>{t('stage.posthogShowRageClicks')}</ContextMenuItem>
      )}
      {shown && <ContextMenuItem onSelect={() => hideHeatmap(frame.id)}>{t('stage.posthogHide')}</ContextMenuItem>}
    </>
  )
}
